export const GET_BALANCE = "/balance";
export const GET_BALANCE_SHOP = "/balance/shop";
export const GET_BALANCE_HISTORY = "/balance/history";
